import type { ReactElement } from 'react'

export interface IRouteParams {
  params: string[]
}

export interface IHubRouteBuilder {
  path: string
  breadcrumb: string | (() => string)
  component: ReactElement
  features: string[]
  props?: IRouteParams
  showBreadcrumb?: boolean
  /** Path (without params) of another hub route shown as the crumb before this one. */
  breadcrumbParentPath?: string
}

let _hubRoutes: IHubRouteBuilder[] = []

export const registerHubRoutes = (routes: IHubRouteBuilder[]): void => {
  _hubRoutes = routes
}

export const getHubRoutes = (): IHubRouteBuilder[] => _hubRoutes
